import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Card, Text } from '@redlink/components/atoms';

export const PreviewContainer = memo(({ style, children, title }) => {
  const { styles } = useStyle();
  return (
    <>
      <Space />
      <View style={[styles.container, style]}>
        {/* <Text style={styles.titleText}>{title || dictionary.preview}</Text> */}
        {/* <Space size={8} /> */}
        <Card style={styles.previewBodyContainer}>{children}</Card>
      </View>
    </>
  );
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    marginEnd: size.previewContainerHorizontalMargin,
    marginTop: size.previewContainerVeticalMargin,
  },
  previewBodyContainer: {
    width: 360,
    height: 640,
    padding: 0,
    borderWidth: 2,
    borderColor: colors.white,
    ...shadow.card
  },
  titleText: {
    fontSize: 14,
    color: colors.gray23,
  },
}));
